import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action, Store} from '@ngrx/store';
import {L10nTranslationService} from 'angular-l10n';
import * as _ from 'lodash';
import {catchError, delayWhen, filter, map, switchMap, withLatestFrom} from 'rxjs/operators';

import {debug} from '../../../rxjs-operators';
import {BaseEffect} from '../../shared/effects/base.effect';
import {ArrayResponse} from '../../shared/models/array-response';
import {SendBackResult} from '../../shared/models/send-back-result';
import * as rootSelectors from '../../shared/reducers';
import {Subscriptions} from '../../subscription/models/subscriptions';
import {SiteWithNoTemplateFaildAction, SiteWithNoTemplateListActionTypes, SiteWithNoTemplateSuccessAction} from '../actions/site-with-no-template-list';
import {DashboardService} from '../services/dashboard.service';

@Injectable()
export class SiteWithNoTemplateListEffect extends BaseEffect {
  private client$ = this.storeClient.select(rootSelectors.selectors.getCurrentClient).pipe(filter(client => !_.isEmpty(client)));

  load$  = createEffect(
    () => {  return this.actions$.pipe(
    ofType(SiteWithNoTemplateListActionTypes.LOAD),
    delayWhen(() => this.client$),
    debug('Load site with no template to validate action received.'),
    withLatestFrom(this.client$),
    switchMap(([action, client]) => this.dashboardService.siteWithNoTemplateAssociated(client.uuid)
                                      .pipe(map((payload: SendBackResult<ArrayResponse<Subscriptions>>) => new SiteWithNoTemplateSuccessAction(payload.data)),
                                            catchError((res: Response) => this.catchResponseError(res)))))});

  protected handleUnhandledError(response: Response): Action { return new SiteWithNoTemplateFaildAction(response.status); }

  constructor(private actions$: Actions,
              translation: L10nTranslationService,
              private storeClient: Store<rootSelectors.AppState>,
              private dashboardService: DashboardService,
              router: Router) {
    super(router, translation);
  }
}
